import { render } from "./FacturadorPOSView.vue?vue&type=template&id=3144dbc5&scoped=true"
import script from "./FacturadorPOSView.vue?vue&type=script&lang=js"
export * from "./FacturadorPOSView.vue?vue&type=script&lang=js"

import "./FacturadorPOSView.vue?vue&type=style&index=0&id=3144dbc5&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3144dbc5"]])

export default __exports__